module.exports = __webpack_public_path__ + "img/shk.c5db23d3.png";